export enum CertificationPlanLevelType {  
  Basic = 1,
  Expert,
  Master,
  General,
  Trainer
}
